import { usePath } from "../libs/path/PathProvider";
import FoodUtils, { Pages, TFoodTab } from "../utils/FoodUtils";
import HomeIcon from "../gui/Icons/HomeIcon";
import ListAltIcon from "../gui/Icons/ListAltIcon";
import SettingsIcon from "../gui/Icons/SettingsIcon";
import Tabs from "../gui/Tabs/Tabs";
import Select from "../gui/Select/Select";
import CalculatorIcon from "../gui/Icons/CalculatorIcon";

const TabIcons : Record<string, JSX.Element> = {
    "home":<HomeIcon/>, 
    "meals":<CalculatorIcon/>,
    "search":<ListAltIcon/>,
    "settings":<SettingsIcon/>
}

export default function(props:{disabled:boolean}){
    const {path,setPath} = usePath()
    const current = FoodUtils.getPage(path)

    const onTab = (id:string) => setPath("/"+id)
    const tab = (row:TFoodTab) => <div className="content">{TabIcons[Select.id(row)]}{Select.text(row)}</div>
    return <footer>
        <Tabs options={Pages} defaultValue={current} tabRenderer={tab} onTab={onTab} disabled={props.disabled}/>
    </footer>
}